import React, { useContext, useEffect, useState } from "react";
import {
  Image,
  SafeAreaView,
  ScrollView,
  Text,
  View,
  useWindowDimensions,
} from "react-native";
import styled, { ThemeProvider } from "styled-components/native";
import { useFonts } from "expo-font";

import { Bound, BoundMagic, DataContext } from "opidcore";
import logo from "../assets/clean_logo_520.png";
import WasteBrand from "../WasteTheme";

import Summary from "./Summary";

export default function OrigWasteApp(props) {
  const [loaded] = useFonts({
    "Red Hat Display": require("../assets/RedHatDisplay.ttf"),
  });

  const [portalData, setPortalData] = useState({});
  const [currentMonth, setCurrentMonth] = useState("2021-03");

  const pathToFetch = "https://localhost:9000/api/v1/portal/demo";
  //'http://192.168.22.117:9000/api/v1/portal/demo'
  useEffect(() => {
    fetch(pathToFetch, { headers: { portalUI: "yes" } }) //portalUI header used in backend api authentication
      .then((r) => r.json())
      .then((r) => {
        setPortalData(r.result);
      });
  }, []);

  const windowSize = useWindowDimensions();

  let myBrand = { ...WasteBrand };
  myBrand.screen = windowSize.width > 768 ? "desktop" : "mobile";

  if (!loaded) {
    return null;
  }

  return (
    <SafeAreaView style={{ paddingTop: 20, width: "100%" }}>
      <ThemeProvider theme={myBrand}>
        <View>
          <Text>Menu</Text>
        </View>
        <Image
          source={logo}
          style={{ width: 390, height: 100 }}
          resizeMode="contain"
        />
        <ScrollView>
          <Summary portalData={portalData} currentMonth={currentMonth} />
          <View style={{ paddingBottom: 150 }}></View>
        </ScrollView>
      </ThemeProvider>
    </SafeAreaView>
  );
}
